<div class="barra-flex-space-between">
  <h1>Configuración RLT</h1>
</div>
<div class="flex-column">
  <div *ngIf="rltReady" class="main">
    <app-parametros-rlt [tipoRlt]="'firmados'"></app-parametros-rlt>
    <app-parametros-rlt [tipoRlt]="'noFirmados'"></app-parametros-rlt>
  </div>
  <div  *ngIf="rltReady" class="guardar-btn">
    <app-boton-accion class="guarda-rlt" [id]="'guardar'" [icono]="'hs-guardar'" [titulo]="'guardar'" [outline]="false" (click)="guardaConfiguracionRlt()"></app-boton-accion>
  </div>
</div>

